angular.module('vastdesk').
  component('polygonListTargeting',  {
    bindings: {
      formName: '@',
      formId: '@',
      allowList: '@',
      searchEndpoint: '@',
      selectedOptions: '<'
    },
    template: require("../templates/polygonListTargeting.html"),
    controllerAs: '$polygonListTargetingCtrl',
    controller: ['$scope', '$timeout', function($scope, $timeout) {
      var self = this;
      // We only allow "Include" as an option for polygon lists
      this.allowlistButtonOptions = [
        {value: '', label: 'All'},
        {value: 'true', label: 'Include'}
      ];

    }]
});
